import { FC } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'

interface IFResetButtonProps {
  onClick: () => void
  className?: string
}

const ResetButton: FC<IFResetButtonProps> = ({ onClick, className }) => {
  return (
    <StyledWrapper color="transparent" onClick={onClick} className={className}>
      <img src="/static/images/activity/reset.svg" className="reset-icon" />
    </StyledWrapper>
  )
}

export default ResetButton

const StyledWrapper = styled(Button)`
  width: 36px;
  height: 36px;
  border: 1px solid ${(props) => props.theme.line.line_3};
  padding: initial;
  .reset-icon {
    width: 18px;
    height: 18px;
  }
`
